import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["searchField"];

  connect() {
    $(this.searchFieldTarget).typeWatch({
      wait: 750,
      captureLength: 1,
      callback: () => {
        this.element.requestSubmit();
      }
    });
  }

  disconnect() {
    $(this.searchFieldTarget).off();
  }
}
